import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import './sermon_outlines.user.screen.scss';
import Pagination from 'react-js-pagination';
import '../../index.scss';
import Header from 'components/header/header.component';
import Footer from 'components/footer/footer.component';
import ResourcesCard from 'components/resources_card/resources_card';
import SelectBox from 'common_components/ui/select_box/select_box.ui';
import { csiMonthSelectionData } from 'helper/constants.helper';
import Navbar from 'components/navbar/navbar.component';
import { GET_SERMON_OUTLINE_LIST } from 'utils/types.utils';
import { getAllPublication } from "models/public.model";
import { getYear, throwError, useSetState } from 'utils/common.utils';
import Spinner from 'common_components/ui/spinner/spinner.ui';
import Eye from '../../assets/icons/Eye.svg'

export default function SermonOutlinesUserScreen(props) {
  const dispatch = useDispatch();
  const sermonList = useSelector(
    (state: any) => state.worship_resources.sermon_outline_list,
  );
  const [state, setState] = useSetState({
    loading: true,
    type: 'sermons',
    search: '',
    limit: 21,
    page: 1,
    year: ''
  });

  const fetchSermonDetailsList = async () => {
    try {
      const data = {
        page: state.page,
        limit: state.limit,
        search: state.search,
        sort: true,
        type: state.type,
      };

      const res: any = await getAllPublication(data);
      dispatch({
        type: GET_SERMON_OUTLINE_LIST,
        payload: res.data,
      });
      setState({
        loading: false,
      });
    } catch (err:any) {
      throwError(err.data ? err.data.desc : "Failed to Sermon details")
    }
  };
  const handleApplyFilters = async (year) => {
    try {
      const data = {
        limit: state.limit,
        page: state.page,
        search: "",
        type: "sermons",
        sort: true,
        year,
      };
      const res: any = await getAllPublication(data);
      dispatch({
        type: GET_SERMON_OUTLINE_LIST,
        payload: res.data,
      });
      setState({ filterModal: false })
    } catch (err:any) {
      throwError(err.data ? err.data.desc : "Failed to filter Sermon details")
    }
  }
  const handlePageChange = (pageNumber) => {
    setState({ activePage: pageNumber, page: pageNumber });
  };
  useEffect(() => {
    fetchSermonDetailsList();
  }, [state.page]);

  return (
    <div className="sermon_outlines_screen">
      <div className="header_wrapper">
      <div className="header">
        <Header />
      </div>
        <div className="navbar_wrapper" style={{ position: 'sticky', top: 0, zIndex: 9999 }}>
          <Navbar {...props} />
        </div>
      </div>
      <div className="sermon_outlines_screen_container">
        <div className="sermon_outlines_header_wrapper">
          <div className="sermon_outlines_heading h2">Worship Resources</div>
          <div className="sermon_outlines_header_line" />
        </div>
        <div className="sermon_outlines_screen_title_wrapper">
          <div className="sermon_outlines_screen_title h1">
            <div className="title_links_wrapper">
              <div className="link h3">
                <NavLink
                  to="/resources/worship_resource/prayer_calendar"
                  className="title_link"
                >
                  Prayer Calendar
                </NavLink>
              </div>
              <div className="link h3">
                <NavLink
                  to="/resources/worship_resource/csi_lectionary"
                  className="title_link"
                >
                  CSI Lectionary
                </NavLink>
              </div>
              <div className="link_1 h3">
                <NavLink
                  to="/resources/worship_resource/sermon_outlines"
                  className="title_link"
                  activeClassName="selected"
                >
                  Sermon Outlines
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className="sermon_outlines_select_box_wrapper">
            <div className="sermon_outlines_select_box">
              <SelectBox
                data={getYear(1947)}
                name=""
                selectedItem={state.month}
                onChange={(selectedOption) => {
                  handleApplyFilters(selectedOption.value)
                  setState({
                    year: selectedOption.value
                  })
                }}
              />
            </div>
        </div>
      <div className="sermon_outlines_body_wrapper">
        {state.loading ? <Spinner />
        : sermonList.docs.length > 0 ? sermonList.docs.map((sermon) => {
          return (
        <div className="sermon_outlines_card_wrapper">
          <ResourcesCard
            onClick={() => {}}
            hoverText="View"
            title={sermon.title}
            type="publications"
            icon={Eye}
            url={sermon.thumbnail}
            pdfLink={sermon.pdf}
          />
        </div>
          )
        }) : <div className="error_text">No sermon data found</div> }
      </div>
      </div>
    <div className="pagination_wrapper">
      <div className="pagination">
        <Pagination
          activePage={state.activePage}
          activeLinkClass="link_active"
          itemsCountPerPage={state.limit}
          totalItemsCount={
            sermonList && sermonList.totalDocs ? sermonList.totalDocs : 20
          }
          pageRangeDisplayed={6}
          firstPageText="<<"
          lastPageText=">>"
          prevPageText="<"
          nextPageText=">"
          itemClassFirst="firstElement"
          onChange={(e) => handlePageChange(e)}
        />
      </div>
    </div>
      <div className="footer_wrapper">
        <Footer />
      </div>
    </div>
  );
}
